import { render, staticRenderFns } from "./ProspectsList.vue?vue&type=template&id=a934a8c6&scoped=true&"
import script from "./ProspectsList.vue?vue&type=script&lang=ts&"
export * from "./ProspectsList.vue?vue&type=script&lang=ts&"
import style0 from "./ProspectsList.vue?vue&type=style&index=0&id=a934a8c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a934a8c6",
  null
  
)

export default component.exports